var SDK_VERSION = '7.3.1';

export { SDK_VERSION };
//# sourceMappingURL=version.js.map
